var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialization1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5969",
    "data-name": "Group 5969",
    transform: "translate(10472 -5721)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10472 5721)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-10468 5740.716) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001---Degree",
    "data-name": "001---Degree",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.386.762a8.356,8.356,0,0,1,.286,1.856,2.753,2.753,0,0,0-2.762.257A10.719,10.719,0,0,0,9.638.759q.721.015,1.479.015C11.55.774,11.971.769,12.386.762Zm-.873,6.36A1.984,1.984,0,1,1,13.5,5.138,1.984,1.984,0,0,1,11.513,7.122ZM.007,3.551A11.128,11.128,0,0,1,.4.179,11.128,11.128,0,0,1,.8,3.551,11.128,11.128,0,0,1,.4,6.924,11.128,11.128,0,0,1,.007,3.551Zm1.2,3.44a13.158,13.158,0,0,0,.388-3.44A13.161,13.161,0,0,0,1.207.111a69.613,69.613,0,0,0,7.6.628,10.213,10.213,0,0,1,.324,2.813c0,.058,0,.112,0,.167A2.749,2.749,0,0,0,9,6.318l-.017.042a69.145,69.145,0,0,0-7.779.631ZM10.088,9.9,9.8,9.233a.4.4,0,0,0-.52-.206l-.668.3.93-2.231a2.775,2.775,0,0,0,1.4.766Zm3.661-.873a.4.4,0,0,0-.52.206l-.294.66-.851-2.037a2.777,2.777,0,0,0,1.4-.766l.928,2.222Zm8-1.924a64.256,64.256,0,0,0-7.7-.714l-.028-.068a2.761,2.761,0,0,0-.535-3.129A11.043,11.043,0,0,0,13.206.747,66.228,66.228,0,0,0,21.75,0a9.359,9.359,0,0,1,.476,3.551A9.4,9.4,0,0,1,21.75,7.1Z",
    transform: "translate(0)",
    fill: "#3f2566"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialization1);
export default __webpack_public_path__ + "static/media/Specialization1.72459a0121c5c939d6b52db751ea5578.svg";
export { ForwardRef as ReactComponent };